<template>
  <div class="text-center mb-2">
    <p
      class="mb-3"
      v-html="$t('lang.bookings.change_pix')"
    />
    <figure class="mb-n1">
      <VueQrcode
        :value="qrCode"
        tag="svg"
        :options="options"
        class="qrcode"
      />
      <img
        class="qrcode_image"
        src="../../assets/img/payments/pix-logo.png"
        alt="pix-logo"
      >
    </figure>
    <b-link
      id="popover"
      @click="copyCode"
    >
      <i class="fa-solid fa-copy" /> {{ $t('lang.bookings.copy_pix') }}
    </b-link>
    <b-popover
      :show="showCopied"
      target="popover"
      placement="top"
    >
      {{ $t('lang.referrals.copied') }}
    </b-popover>
    <b-link
      class="btn btn_1 full-width mt-3"
      @click="validatePayment"
    >
      {{ $t('lang.bookings.validate_pix_payment') }}
    </b-link>
  </div>
</template>
<script>

import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
  name: 'PixPayment',
  components: {
    VueQrcode,
  },
  props: {
    qrCode: {
      type: String,
      required: true,
    },
    returnUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showCopied: false,
      options: {
        color: {
          color: {
            dark: '#051460', // Color del QR.
            light: '#ffffff', // Fondo del QR.
          },
        },
      },
    };
  },

  methods: {
    copyCode() {
      navigator.clipboard.writeText(this.qrCode);
      this.showCopied = true;

      setTimeout(() => {
        this.showCopied = false;
      }, 2000);
    },
    validatePayment() {
      this.$router.push(this.returnUrl);
    },
  },
};
</script>

<style scoped>
figure {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 0;
  position: relative;
  width: auto; /* Ajusta dinámicamente el tamaño del contenedor */
  background-color: transparent;
  margin-top: -1rem;
}
.qrcode{
  width: 250px; /* Tamaño fijo para que no se estire */
  height: 250px; /* Mantén proporción cuadrada */
  max-width: 115%;
}
.qrcode_image {
  height: 50px; /* Tamaño ajustado */
  width: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 1;
}
</style>
